import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  Router,
  ActivatedRoute,
  RouterModule,
  NavigationEnd,
} from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-spu-manager',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule, ButtonModule],
  templateUrl: './spu-manager.component.html',
  styleUrl: './spu-manager.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpuManagerComponent implements OnInit, OnDestroy {
  spuTabs = [
    {
      labelKey: 'goods.spu.tabs.standard_product',
      value: 'ordinary',
      disabled: false,
    },
    {
      labelKey: 'goods.spu.tabs.package_product',
      value: 'package',
      disabled: false,
    },
  ];
  activeTab = 'ordinary';
  private navSub?: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.updateActiveTabFromRoute();
    this.navSub = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.updateActiveTabFromRoute();
      }
    });
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }

  onTabChange(event: { index: number }): void {
    const tab = this.spuTabs[event.index];
    // Prevent navigation if tab is disabled
    if (tab.disabled) {
      return;
    }
    this.activeTab = tab.value;
    this.router.navigate([tab.value], { relativeTo: this.route });
  }

  private updateActiveTabFromRoute(): void {
    const child = this.route.firstChild;
    const seg = child?.snapshot.url[0]?.path;
    this.activeTab = seg === 'package' ? 'package' : 'ordinary';
  }
}
